import {Button, Col, Divider, Row, Tooltip} from "antd";
import {moneyCeil, moneyFormat, quantityFormat} from "../../utils/stringUtils";
import React, {Fragment} from "react";
import {Link} from "react-router-dom";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {modifyArrayDataSource} from "../../utils/arrayUltils";
import {LocalStore} from "../../utils/LocalStore";

interface Props {
	draftOrder: any
	balanceObj: any
	balance: any
	t: Function
	onCreateOrder: Function
}

export const TenantDeposit = (props: Props) => {
	const {draftOrder, balanceObj, balance, t} = props

	let listCarts: Array<any> = Array.isArray(draftOrder.merchants) ? draftOrder.merchants : [];

	let totalLink = 0;
	let arrayModify = [];
	let totalQuantity = 0;
	let lackOfMoney = false;

	listCarts.forEach(x => {
		if (x.crossedThreshold === false) {
			arrayModify = modifyArrayDataSource(x);
			totalLink = totalLink + arrayModify.length;
			arrayModify.forEach(item => {
				totalQuantity = totalQuantity + item.quantity;
			});
		}
	});

	const crossedThreshold: Array<any> = listCarts.filter(x => x.crossedThreshold === false);

	// kiểm tra số tiền cần đặt cọc và số tiền dư của tài khoản
	if (draftOrder.emdAmount > balanceObj.balance + balanceObj.creditLimit) {
		lackOfMoney = true
	}
	let currentProjectInfo: any = LocalStore.getInstance().read('currentProjectInfo');
	let suspensionSchedule: any = currentProjectInfo.suspensionSchedule;
	let disabled = suspensionSchedule && Array.isArray(suspensionSchedule.appliedFor) && !!suspensionSchedule.appliedFor.find((x: any) => x === "ALL" || x === "ORDER")

	return (
		<div className={`_order-financial-info sidebar__financialinfo ${lackOfMoney ? 'warning' : ''}`}>
			<div className="sidebar__financialinfo_box">
				<Row className={'mgbt10'}>
					<Col md={24} className={'txt-size-h6 txt-color-black robotobold mgbt5'}>{t('cartCheckout.product_info')}</Col>
					<Col md={24} className={'txt-size-h7 txt-color-black robotoregular mgbt5 justify-content-between dpl-flex'}>
						<span>{t('cartCheckout.seller')}:</span>
						<span>{listCarts.length}</span>
					</Col>
					<Col md={24} className={'txt-size-h7 txt-color-black robotoregular justify-content-between dpl-flex'}>
						<span>{t('cartCheckout.link_total')}:</span>
						<span>{totalLink}</span>
					</Col>
				</Row>
				<Divider />
				<Row className={'mgbt15'}>
					<Col md={24} className={'txt-size-h6 txt-color-black robotobold mgbt5'}>{t('cartCheckout.order_info')}</Col>
					<Col md={24} className={'txt-size-h7 txt-color-black robotoregular mgbt5 justify-content-between dpl-flex'}>
						<span>{t('cartCheckout.provisional_fee')}:</span>
						<span className={'_totalMoney-page'}>{moneyFormat(moneyCeil(draftOrder.totalFee))}</span>
					</Col>
					<Col md={24} className={'txt-size-h7 txt-color-black robotoregular mgbt5 justify-content-between dpl-flex'}>
						<span>{t('cartCheckout.provisional_cal')} (<span className={'_totalQuantity-page'}>{quantityFormat(totalQuantity)}</span> {t('cartCheckout.product')}):</span>
						<span className={'_totalMoney-page'}>{moneyFormat(moneyCeil(draftOrder.exchangedTotalValue))}</span>
					</Col>
					<Col md={24} className={'txt-size-h7 txt-color-black robotoregular mgbt5 justify-content-between dpl-flex'}>
						<span>{t('cartCheckout.deposit')} {draftOrder.emdPercent}%:</span>
						<span className={'_deposit-page txt-size-h5 bold'}>{moneyFormat(moneyCeil(draftOrder.emdAmount))}</span>
					</Col>
					{
						lackOfMoney
						&&
						<React.Fragment>
							<Col md={24} className={'txt-size-h7 txt-color-black robotoregular mgbt5 justify-content-between dpl-flex'}>
								<span>{t('cartCheckout.balance_account')}:</span>
								<span className={'_balance-account txt-size-h6'}>
                                                {
													balance >= 0 ? `+${moneyFormat(balance)}` : `${moneyFormat(balance)}`
												}
                                            </span>
							</Col>
							<Col md={24} className={'txt-size-h7 txt-color-black robotoregular mgbt5 justify-content-between dpl-flex'}>
								<span>{t('cartCheckout.lack_of_money')}:</span>
								<span className={'_lack-of-money txt-size-h6 txt-color-red'}>{moneyFormat(moneyCeil(draftOrder.emdAmount - balance))}</span>
							</Col>
						</React.Fragment>
					}
				</Row>
				<Row>
					{
						crossedThreshold.length > 0 && <Col md={24}>

							{
								lackOfMoney
									?
									(
										<Fragment>
											<Button block className={'_btn-recharge btn-recharge mgbt5'}>{t('cartCheckout.recharge')}</Button>
											<span className='flr'>
                                                    <Link target="_blank" to={`/profile/faqs?recharge`}>
                                                        {t('cartCheckout.recharge_guide')}
                                                    </Link>
                                                    <Tooltip placement="top" title={t('cartCheckout.guide_recharge_into_account')}>
                                                        <QuestionCircleOutlined className={'pdl5 txt-size-h8 txt-color-blue opacity6'}/>
                                                    </Tooltip>
                                                </span>
										</Fragment>
									)
									:
									<Button
										htmlType={'button'}
										block
										disabled={disabled}
										className={'_btn-show-modal-confirm btn--blue'}
										onClick={() => props.onCreateOrder()}
									>
										{t('cartCheckout.deposit_now')}
									</Button>
							}
						</Col>
					}
				</Row>
			</div>
		</div>
	)
}
